<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
<div class="border-b border-solid border-slate-300"></div>

<div class="wrapper flex flex-col gap-4">
  <h1 class="mat-headline-4 !mb-0">Tags</h1>

  <pr-content-container>
    <p class="font-bold">Calendar Event Tags</p>
    <pr-calendar-event-tags [brand]="brand$ | async" />
  </pr-content-container>

  <pr-content-container>
    <p class="font-bold">Appointment Tags</p>
    <pr-brand-appointment-tags [brand]="brand$ | async" />
  </pr-content-container>

  <pr-content-container>
    <p class="font-bold">Patient Tags</p>
    <pr-patient-tags [brand]="brand$ | async" />
  </pr-content-container>

  <pr-content-container>
    <p class="font-bold">Note Tags</p>
    <pr-patient-note-tags [brand]="brand$ | async" />
  </pr-content-container>

  <pr-content-container>
    <p class="font-bold">Contact Tags</p>
    <pr-contact-tags [brand]="brand$ | async" />
  </pr-content-container>
</div>
